import React from 'react';
import { IntlProvider } from 'react-intl-next';
import { Text } from "@atlaskit/primitives/compiled";
import { DEFAULT_LOCALE, getCodesFromLocale, useLazyMessages } from './utils';
export var ProformaIntlProvider = function ProformaIntlProvider(_ref) {
  var _getCodesFromLocale;
  var children = _ref.children,
    locale = _ref.locale,
    messages = _ref.messages;
  var _ref2 = (_getCodesFromLocale = getCodesFromLocale(locale)) !== null && _getCodesFromLocale !== void 0 ? _getCodesFromLocale : {},
    language = _ref2.language,
    country = _ref2.country;
  var lazyMessages = useLazyMessages(messages, language !== null && language !== void 0 ? language : DEFAULT_LOCALE, country);
  if (lazyMessages === undefined) {
    return null;
  }
  return /*#__PURE__*/React.createElement(IntlProvider, {
    messages: lazyMessages,
    locale: country && "".concat(language, "-").concat(country) || language || locale.replace('_', '-'),
    defaultLocale: DEFAULT_LOCALE,
    defaultRichTextElements: {
      b: function b(chunks) {
        return /*#__PURE__*/React.createElement(Text, {
          weight: "bold"
        }, chunks);
      },
      strong: function strong(chunks) {
        return /*#__PURE__*/React.createElement(Text, {
          as: "strong"
        }, chunks);
      }
    }
  }, children);
};